import { BackgroundJobListPage } from "@/features/background-job/pages/BackgroundJobListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/background-job/transaction/")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["background_job.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: BackgroundJobListPage,
});
